import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import Box from "@mui/material/Box";
import AppShell from "components/AppShell";
import Faq from "components/Dashboard/Faq";
import Performance from "components/Dashboard/Performance";
import { exitFullScreen } from "utils";

const MenuItems = [
    { title: "Home", link: "/practice" },
    { title: "FAQs", link: "/practice/faq" },
];

export default function Dashboard() {
    React.useLayoutEffect(() => exitFullScreen(), []);

    return (
        <Routes>
            <Route path="/" element={<DashboardLayout />}>
                <Route index element={<Performance />} />
                <Route
                    path="faq"
                    element={
                        <React.Suspense fallback={<>...</>}>
                            <Faq />
                        </React.Suspense>
                    }
                />
            </Route>
        </Routes>
    );
}

function DashboardLayout() {
    return (
        <AppShell
            menuItems={MenuItems} hideAnnouncement
            sx={{ backgroundColor: '#001929' }} placeAtTop
        >
            <Box width={'100%'}>
                <Outlet />
            </Box>
        </AppShell>
    );
}